<template>
    <button
        type="button"
        :class="buttonClasses"
        @click="$emit('testclick')"
    >
        <span>
            <div class="py-2 px-5 whitespace-nowrap">
                <slot />
            </div>
        </span>
    </button>
</template>

<script>
export default {
    name: "VButton",
    props: {
        variant: {
            type: String,
            default: "green", // default variant
            validator: (value) => ["green", "dark", "darker", "red"].includes(value)
        },
        group: {
            type: String,
            default: "none", // default variant
            validator: (value) => ["left", "right", "middle", "none"].includes(value)
        }
    },
    mounted() {
        console.log("test Mounted")
    },
    computed: {
        buttonClasses() {
            console.log("Computing classes")
            // Base classes common to both variants
            let classes = "text-sm focus:outline-none whitespace-nowrap bg-opacity-100 text-white hover:bg-opacity-70 hover:dark:bg-opacity-70";
            if(this.group == "none") {
                classes += " rounded-md"
            } else if(this.group == "left") {
                classes += " rounded-l-md"
            } else if(this.group == "middle") {
                classes += " border-l border-grey border-opacity-25 rounded-none -ml-px"
            } else if(this.group == "right") {
                classes += " border-l border-grey border-opacity-25 rounded-r-md -ml-px"
            }
            if (this.variant === "green") {
                classes += " dark:bg-green dark:focus:ring-green bg-green focus:ring-green shadow-green focus:ring";
            } else if (this.variant === "dark") {
                classes += " dark:bg-dark dark:focus:ring-darker bg-dark focus:ring-darker focus:ring";
            } else if (this.variant === "darker") {
                classes += " dark:bg-darker dark:focus:ring-darker bg-darker focus:ring-darker"
            } else if(this.variant === "red") {
                classes += " dark:bg-red dark:focus:ring-red bg-red focus:ring-red"
            }

            return classes;
        }
    }
};
</script>

<style scoped>
/* Add any scoped styles here if needed */
</style>